import { Link } from "react-router-dom";
import { Facebook } from "lucide-react";
import { COMMITTEE_NAME, NAV_LINKS, CANDIDATE, FACEBOOK_URL, LOGO } from "../lib/config";

export const Footer = () => (
  <footer className="bg-[hsl(var(--navy))] text-white" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-24">
      <div className="grid md:grid-cols-12 gap-10 md:gap-8">
        <div className="md:col-span-6">
          <img
            src={LOGO}
            alt="Jeff Trickler for Ontario County Treasurer"
            className="h-28 md:h-36 w-auto rounded-md ring-1 ring-white/15"
            data-testid="footer-logo"
          />
          <p className="mt-6 text-slate-300 max-w-md leading-relaxed">
            {CANDIDATE.tagline}
          </p>
          <a
            href={FACEBOOK_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-facebook-btn"
            className="focus-ring group mt-8 inline-flex items-center gap-3 bg-white/10 hover:bg-[#1877F2] border border-white/20 hover:border-transparent px-6 py-3 rounded-sm transition-colors"
          >
            <Facebook size={20} className="text-white" />
            <span className="font-semibold text-white">Follow on Facebook</span>
          </a>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-overline text-slate-400 font-semibold mb-4">Explore</p>
          <ul className="space-y-3">
            {NAV_LINKS.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  data-testid={`footer-nav-${link.label.toLowerCase()}`}
                  className="text-slate-300 hover:text-white transition-colors focus-ring"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-overline text-slate-400 font-semibold mb-4">The Campaign</p>
          <p className="text-slate-300 leading-relaxed text-sm">
            A dignified, accountable Treasurer's Office for the residents of Ontario County, New York.
          </p>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        {/* NY-required disclaimer — present on EVERY page */}
        <p
          className="text-sm font-semibold text-white border border-white/30 rounded-sm px-4 py-2.5 inline-block"
          data-testid="paid-for-disclaimer"
        >
          Paid for by {COMMITTEE_NAME}
        </p>
        <p className="text-xs text-slate-400">
          &copy; {new Date().getFullYear()} {COMMITTEE_NAME}. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);
